import { render } from "./customBoxInfo.vue?vue&type=template&id=29f45f9c"
import script from "./customBoxInfo.vue?vue&type=script&lang=js"
export * from "./customBoxInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__